import { useState, useEffect } from "react";
import Button from "../../components/ui/button/Button";
import { X } from "lucide-react";

const VendorProductFilterForm = ({ onSubmit, onClose, initialValues, setShow }) => {
    const [formData, setFormData] = useState({
        productDescription: "",
        k: 10,
        gender: "",
        color: "",
        material: "",
        category: "",
    });

    useEffect(() => {
        if (initialValues) {
            setFormData((prev) => ({ ...prev, ...initialValues }));
        }
    }, [initialValues]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
        if (setShow) setShow(false);
        if (onClose) onClose();
    };

    const handleClear = () => {
        const cleared = {
            productDescription: "",
            k: 10,
            gender: "",
            color: "",
            material: "",
            category: "",
        };
        setFormData(cleared);
        // onSubmit(null); // Clear filters in parent
        // if (setShow) setShow(false);
        // if (onClose) onClose();
    }

    return (
        <div className="w-full">
            <div className="mb-6 flex justify-between items-center">
                <div className="">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                        Product Search
                    </h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        Search products by specific attributes.
                    </p></div>
                <button
                    type="button"
                    onClick={() => {
                        if (setShow) setShow(false);
                        if (onClose) onClose();
                    }}
                    className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                >
                    <X size={20} className="text-gray-500" />
                </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Product Description */}
                    <div className="md:col-span-2">
                        <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
                            Product Description
                        </label>
                        <input
                            type="text"
                            name="productDescription"
                            value={formData.productDescription}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500"
                            placeholder="e.g. male, summer floral dress"
                        />
                    </div>

                    {/* K (Limit) */}
                    <div>
                        <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
                            Results Limit (k)
                        </label>
                        <input
                            type="number"
                            name="k"
                            value={formData.k}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500"
                            placeholder="e.g. 10"
                        />
                    </div>

                    {/* Gender */}
                    <div>
                        <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
                            Gender
                        </label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500"
                        >
                            <option value="">Select Gender</option>
                            <option value="men">Male</option>
                            <option value="women">Female</option>
                            <option value="unisex">Unisex</option>
                        </select>
                    </div>

                    {/* Color */}
                    <div>
                        <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
                            Color
                        </label>
                        <input
                            type="text"
                            name="color"
                            value={formData.color}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500"
                            placeholder="e.g. red, blue"
                        />
                    </div>

                    {/* Material */}
                    <div>
                        <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
                            Material
                        </label>
                        <input
                            type="text"
                            name="material"
                            value={formData.material}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500"
                            placeholder="e.g. cotton, silk"
                        />
                    </div>

                    {/* Category */}
                    <div className="md:col-span-2">
                        <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
                            Category
                        </label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500"

                        >
                            <option value="upper-body">Upper Body</option>
                            <option value="lower-body">Lower Body</option>
                            <option value="full-body">Full Body</option>
                            <option value="outerwear">Outerwear</option>
                            <option value="footwear">Footwear</option>
                            <option value="carrying-goods">Carrying Goods</option>
                            <option value="jewelry-timepieces">Jewelry Timepieces</option>
                            <option value="head-eyewear">Head & Eyewear</option>
                            <option value="textile-accents">Textile Accents</option>
                            <option value="waistwear">Waistwear</option>
                            <option value="upper-body">Upper Body</option>
                        </select>
                    </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="secondary"
                        className="px-6"
                        onClick={handleClear}
                        type="button"
                    >
                        Clear
                    </Button>
                    <Button
                        variant="primary"
                        className="px-6"
                        type="submit"
                    >
                        Apply Filters
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default VendorProductFilterForm;
